import getEnvironmentVariable from '../../utils/get-environment-variable';
import { Config } from './glp.types';

const getGlpConfig = (): Config => ({
  BASE_URL: getEnvironmentVariable('GLP_BASE_URL'),
});

export default getGlpConfig;
